import { Fragment } from "preact";
import useMeowLightboxContext from "../context";

export const Counter = () => {
  const { imagesNumber, currentIndex, currentSeparatedIndexDifference } = useMeowLightboxContext();

  return (
    <Fragment>
      <span className="current-slide">{ currentIndex - currentSeparatedIndexDifference + 1 }</span>/
      <span className="number-of-slides">{imagesNumber}</span>
    </Fragment>
  );
};
